import { Injectable } from '@angular/core';
import { SheetsStoreService } from '../../../services';
import { COLLECTIONS, Connection, FOLDERID, Part } from '@dis/models'

@Injectable({
  providedIn: 'root'
})
export class ConnectionsSheetStore extends SheetsStoreService<Connection> {

  protected collectionName = COLLECTIONS.CONNECTIONS;
  protected override collectionRows = '1:1000';

  protected override collectionSheet = 'exportConnectionList';
}